import * as React from 'react';
import { useFloating, autoUpdate, offset, flip, shift, useListNavigation, useInteractions } from '@floating-ui/react';

const DropdownContext = /*#__PURE__*/ React.createContext(null);
DropdownContext.displayName = 'DropdownContext';
const useDropdownContext = ()=>{
    const context = React.useContext(DropdownContext);
    if (context === null) {
        throw new Error('No DropdownContext available.');
    }
    return context;
};
const ButtonDropdownProvider = ({ 'aria-label': ariaLabel , children , isDisabled , isInvalid , isOpen , offset: offset$1 =3 , placement ='bottom-start' , isRequired , setIsOpen , onChange , value: valueProp , cols =1 , itemSizes , focusItemOnHover =true , orientation ='vertical' , loop ,  })=>{
    const [value1, setValue] = React.useState(valueProp);
    const contentId = React.useId();
    const { context: floatingContext  } = useFloating({
        placement,
        open: isOpen,
        onOpenChange: (floatOpen)=>{
            // this function will called when arrow up/down is pressed
            floatOpen && setIsOpen(true);
        },
        whileElementsMounted: autoUpdate,
        middleware: [
            offset(offset$1),
            flip(),
            shift()
        ]
    });
    const itemsRef = React.useRef([]);
    const [activeIndex, setActiveIndex] = React.useState(null);
    const [selectedIndex, setSelectedIndex] = React.useState(null);
    const listNavigation = useListNavigation(floatingContext, {
        listRef: itemsRef,
        activeIndex,
        selectedIndex,
        onNavigate: setActiveIndex,
        focusItemOnHover,
        orientation,
        cols,
        itemSizes,
        loop
    });
    const { getReferenceProps , getFloatingProps , getItemProps  } = useInteractions([
        listNavigation
    ]);
    const open = React.useCallback(()=>{
        setIsOpen(true);
    }, [
        setIsOpen
    ]);
    const close = React.useCallback(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const toggle = React.useCallback(()=>{
        setIsOpen((prevValue)=>!prevValue
        );
    }, [
        setIsOpen
    ]);
    const handleSelect = React.useCallback((index, value)=>{
        setSelectedIndex(index);
        setIsOpen(false);
        setValue(value);
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    }, [
        onChange,
        setIsOpen
    ]);
    React.useEffect(()=>{
        if (valueProp !== value1) {
            setValue(valueProp);
        }
    }, [
        valueProp,
        value1
    ]);
    return /*#__PURE__*/ React.createElement(DropdownContext.Provider, {
        value: {
            'aria-label': ariaLabel,
            contentId,
            isDisabled,
            isInvalid,
            isOpen,
            floatingProps: {
                floatingContext,
                getReferenceProps,
                getFloatingProps,
                getItemProps,
                itemsRef
            },
            isRequired,
            value: value1,
            toggle,
            open,
            close,
            cols,
            activeIndex,
            selectedIndex,
            handleSelect
        }
    }, children);
};

export { ButtonDropdownProvider, useDropdownContext };
//# sourceMappingURL=ButtonDropdownContext.js.map
